import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface WatchHistoryItem {
//   videoId: string;
// }

// interface WatchHistoryState {
//   watchHistoryVideos: WatchHistoryItem[];
// }

const initialState: any = {
    watchHistoryVideos: []
};

export const watchHistorySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setWatchHistoryVideos: (state, action: PayloadAction<any[]>) => {
      state.watchHistoryVideos = action.payload;
    }
  }
});

export const { setWatchHistoryVideos } = watchHistorySlice.actions;

export default watchHistorySlice.reducer;
